class SizeGuide extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;

    this.pageContent = this.querySelector('page-content');
    this._onClick = this.#onClick.bind(this);
    this._onReady = this.#onReady.bind(this);

    document.addEventListener('click', this._onClick);
    this.pageContent?.addEventListener('page-content:ready', this._onReady);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onClick);
    this.pageContent?.removeEventListener('page-content:ready', this._onReady);
  }

  #onClick(event) {
    const trigger = event.target.closest('[data-size-guide-trigger]');
    if (!trigger || !this.pageContent) return;

    const url = trigger.getAttribute('href');
    if (!url) return;

    event.preventDefault();
    this.pageContent.open(url, trigger);
  }

  #onReady(event) {
    const root = event.detail?.contentEl;
    if (!root) return;

    this.#initTabs(root);
    this.#wrapTables(root);
  }

  #initTabs(root) {
    for (const tab of root.querySelectorAll('[data-size-guide-tab]')) {
      tab.addEventListener('click', (event) => this.#openTab(event, root));
    }
  }

  #openTab(event, root) {
    const tab = event.currentTarget;
    const panelId = tab.getAttribute('aria-controls');

    for (const panel of root.querySelectorAll('[data-size-guide-panel]')) {
      panel.hidden = true;
    }
    for (const item of root.querySelectorAll('[data-size-guide-tab]')) {
      item.setAttribute('aria-selected', 'false');
    }

    const panel = panelId ? root.querySelector(`#${CSS.escape(panelId)}`) : null;
    if (panel) panel.hidden = false;
    tab.setAttribute('aria-selected', 'true');
  }

  #wrapTables(root) {
    for (const table of root.querySelectorAll('.kt-rte table')) {
      if (table.parentElement?.classList.contains('table-wrapper')) continue;
      const wrapper = document.createElement('div');
      wrapper.className = 'table-wrapper';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide);
}
